import axios from 'axios';
import { packageSuppliersApi } from './endpoints';
import aplicacionesApi from '../aplicaciones';
import { safeSessionStorage, useSessionStorage, isClient } from 'legacyfrontend/helpers/ssr-helper';

const getToken = async () => {
  if (!isClient) {
    return '';
  }

  const { hostname } = isClient ? window.location : { hostname: '' };
  try {
    const res = await aplicacionesApi.obtenerAplicacion(hostname);
    return res.access_token;
  } catch (error) {
    console.error('Error getting token:', error);
    if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
      safeSessionStorage.setItem(`[TOKEN][${new Date()}]`, JSON.stringify(error));
    }
    return '';
  }
};

const client = axios.create({
  baseURL: process.env.RAZZLE_API_PACKAGE_PROVIDERS,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

client.interceptors.request.use(async (config) => {
  if (config.headers.Authorization) {
    return config;
  }

  const token = await getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const newToken = await getToken();

      originalRequest.headers.Authorization = `Bearer ${newToken}`;

      return client(originalRequest);
    }

    return Promise.reject(error);
  }
);

export const getAirportSuggestions = async (kind) =>
  (await client.get(packageSuppliersApi.getAirportSuggestions(), { params: { kind } }))?.data;

export const getPackage = async (packageId) =>
  (await client.get(packageSuppliersApi.getPackageById(packageId)))?.data;

export const getPackageConfiguration = async (packageConfigurationId) =>
  (await client.get(packageSuppliersApi.getPackageConfigurationById(packageConfigurationId)))?.data;

export const getPackageAndHotelInformation = async (packageId, hotelInformationId) =>
  (
    await client.get(
      packageSuppliersApi.getPackageByIdAndHotelInformationId(packageId, hotelInformationId)
    )
  )?.data;

export const getPackageDepartures = async (packageId, filters) =>
  (
    await client.get(packageSuppliersApi.getDeparturesByPackageId(packageId), {
      params: filters,
    })
  )?.data;

export const getPackageConfigurations = async (packageId, filters, token) => {
  if (token) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      params: filters,
    };

    return (await client.get(packageSuppliersApi.getConfigurationsByPackageId(packageId), config))
      ?.data;
  }

  return (
    await client.get(packageSuppliersApi.getConfigurationsByPackageId(packageId), {
      params: filters,
    })
  )?.data;
};
